const ROLE_OVERRIDE_KEY = "mbo-role-override";
const GROUP_OVERRIDE_KEY = "mbo-group-override";

let listeners: Array<() => void> = [];

function emitChange() {
  for (const listener of listeners) listener();
}

export function subscribe(listener: () => void): () => void {
  listeners = [...listeners, listener];
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}

export function getSnapshot(): string | null {
  return sessionStorage.getItem(ROLE_OVERRIDE_KEY);
}

export function getRoleOverride(): string | null {
  return sessionStorage.getItem(ROLE_OVERRIDE_KEY);
}

export function setRoleOverride(role: string | null): void {
  if (role) sessionStorage.setItem(ROLE_OVERRIDE_KEY, role);
  else sessionStorage.removeItem(ROLE_OVERRIDE_KEY);
  if (role !== "Gruppmedlem") {
    sessionStorage.removeItem(GROUP_OVERRIDE_KEY);
  }
  emitChange();
}

export function getGroupOverride(): string | null {
  return sessionStorage.getItem(GROUP_OVERRIDE_KEY);
}

export function setGroupOverride(groupName: string | null): void {
  if (groupName) sessionStorage.setItem(GROUP_OVERRIDE_KEY, groupName);
  else sessionStorage.removeItem(GROUP_OVERRIDE_KEY);
  emitChange();
}
